const CharCreate = {
    points: 25,
    attrModCost: [
        {mod: -2, cost: 2},
        {mod: -1, cost: 1},
        {mod: 0, cost: 0},
        {mod: 1, cost: -1},
        {mod: 2, cost: -2},
        {mod: 3, cost: -3},
        {mod: 4, cost: -5},
        {mod: 5, cost: -7},
        {mod: 6, cost: -9},
        {mod: 7, cost: -12},
        {mod: 8, cost: -15}
    ],
    assignMap: {
        val: 'Wert',
        s: 'Stufe',
        v: 'Verteidigungswert',
        tr: 'Traglast',
        bs: 'Bewusstl.schw.',
        ts: 'Todesschwelle',
        ws: 'Wundschwelle',
        ep: 'Erholungsproben',
        mr: 'Myst. Rüstung'
    },
    assign: {
        0: {s: 0, v: 0, tr: 0, bs: 0, ts: 0, ws: 0, ep: 0, mr: 0},
        1: {s: 2, v: 2, tr: 10, bs: 2, ts: 4, ws: 3, ep: 1, mr: 0},
        2: {s: 2, v: 2, tr: 15, bs: 4, ts: 6, ws: 3, ep: 1, mr: 0},
        3: {s: 2, v: 3, tr: 20, bs: 6, ts: 8, ws: 4, ep: 1, mr: 0},
        4: {s: 3, v: 3, tr: 25, bs: 8, ts: 11, ws: 4, ep: 1, mr: 0},
        5: {s: 3, v: 4, tr: 30, bs: 10, ts: 13, ws: 5, ep: 1, mr: 1},
        6: {s: 3, v: 4, tr: 40, bs: 12, ts: 15, ws: 5, ep: 1, mr: 1},
        7: {s: 4, v: 5, tr: 50, bs: 14, ts: 18, ws: 6, ep: 2, mr: 1},
        8: {s: 4, v: 5, tr: 60, bs: 16, ts: 20, ws: 6, ep: 2, mr: 1},
        9: {s: 4, v: 6, tr: 70, bs: 18, ts: 22, ws: 7, ep: 2, mr: 1},
        10: {s: 5, v: 6, tr: 80, bs: 20, ts: 25, ws: 7, ep: 2, mr: 2},
        11: {s: 5, v: 7, tr: 95, bs: 22, ts: 27, ws: 8, ep: 2, mr: 2},
        12: {s: 5, v: 7, tr: 110, bs: 24, ts: 29, ws: 8, ep: 2, mr: 2},
        13: {s: 6, v: 8, tr: 125, bs: 26, ts: 32, ws: 9, ep: 3, mr: 2},
        14: {s: 6, v: 8, tr: 140, bs: 28, ts: 34, ws: 9, ep: 3, mr: 2},
        15: {s: 6, v: 9, tr: 155, bs: 30, ts: 36, ws: 10, ep: 3, mr: 3},
        16: {s: 7, v: 9, tr: 175, bs: 32, ts: 39, ws: 10, ep: 3, mr: 3},
        17: {s: 7, v: 10, tr: 195, bs: 34, ts: 41, ws: 11, ep: 3, mr: 3},
        18: {s: 7, v: 10, tr: 215, bs: 36, ts: 43, ws: 11, ep: 3, mr: 3},
        19: {s: 8, v: 11, tr: 235, bs: 38, ts: 46, ws: 12, ep: 4, mr: 3},
        20: {s: 8, v: 11, tr: 255, bs: 40, ts: 48, ws: 12, ep: 4, mr: 4},
        21: {s: 8, v: 12, tr: 280, bs: 42, ts: 50, ws: 13, ep: 4, mr: 4},
        22: {s: 9, v: 12, tr: 305, bs: 44, ts: 53, ws: 13, ep: 4, mr: 4},
        23: {s: 9, v: 13, tr: 330, bs: 46, ts: 55, ws: 14, ep: 4, mr: 4},
        24: {s: 9, v: 13, tr: 355, bs: 48, ts: 57, ws: 14, ep: 4, mr: 4},
        25: {s: 10, v: 14, tr: 380, bs: 50, ts: 60, ws: 15, ep: 5, mr: 5},
        26: {s: 10, v: 14, tr: 410, bs: 52, ts: 62, ws: 15, ep: 5, mr: 5},
        27: {s: 10, v: 15, tr: 440, bs: 54, ts: 64, ws: 16, ep: 5, mr: 5},
        28: {s: 11, v: 15, tr: 470, bs: 56, ts: 67, ws: 16, ep: 5, mr: 5},
        29: {s: 11, v: 16, tr: 500, bs: 58, ts: 69, ws: 17, ep: 5, mr: 5},
        30: {s: 11, v: 16, tr: 530, bs: 60, ts: 71, ws: 17, ep: 5, mr: 6}
    },
    talente: 8,
    fertigkeiten: 7,
    races: {
        elf: {
            ges: 12,
            str: 10,
            zae: 8,
            wah: 11,
            wil: 11,
            cha: 11,
            bew: '14',
            karma: 4,
            bonus: 'Nachtsicht'
        },
        mensch: {
            ges: 10,
            str: 10,
            zae: 10,
            wah: 10,
            wil: 10,
            cha: 10,
            bew: '12',
            karma: 5,
            bonus: 'Vielseitigkeit'
        },
        obsidianer: {
            ges: 8,
            str: 18,
            zae: 13,
            wah: 9,
            wil: 10,
            cha: 9,
            bew: '10',
            karma: 3,
            bonus: 'Erhöhte Wundschwelle (+3), Natürliche Rüstung (3)'
        },
        ork: {
            ges: 10,
            str: 13,
            zae: 11,
            wah: 10,
            wil: 8,
            cha: 9,
            bew: '12',
            karma: 5,
            bonus: 'Gahad, Nachtsicht'
        },
        troll: {
            ges: 10,
            str: 14,
            zae: 12,
            wah: 9,
            wil: 11,
            cha: 10,
            bew: '14',
            karma: 3,
            bonus: 'Wärmesicht'
        },
        tskrang: {
            ges: 11,
            str: 10,
            zae: 11,
            wah: 10,
            wil: 10,
            cha: 11,
            bew: '12',
            karma: 4,
            bonus: 'Kiemen, Schwanzkampf'
        },
        windling: {
            ges: 11,
            str: 4,
            zae: 8,
            wah: 11,
            wil: 10,
            cha: 12,
            bew: '6 / 16',
            karma: 6,
            bonus: 'Astralsicht, Erhöhte Körperliche Verteidigung (+2), Flugfähigkeit',
        },
        zwerg: {
            ges: 9,
            str: 10,
            zae: 12,
            wah: 11,
            wil: 11,
            cha: 10,
            bew: '10',
            karma: 4,
            bonus: 'Starker Rücken, Wärmesicht'
        }
    },
    attributes: [
        {pfield: 'none', title: 'none', tt: '-keines-'},
        {pfield: 'ges', title: 'Ges', tt: 'Geschicklichkeit'},
        {pfield: 'str', title: 'Str', tt: 'Stärke'},
        {pfield: 'wah', title: 'Wah', tt: 'Wahrnehmung'},
        {pfield: 'zae', title: 'Zäh', tt: 'Zähigkeit'},
        {pfield: 'wil', title: 'Wil', tt: 'Willenskraft'},
        {pfield: 'cha', title: 'Cha', tt: 'Charisma'},
    ],
    lpstart: [
        100,
        200,
        300,
        500
    ],
    attribute_raise_cost: [
        {r: 1, c: 800},
        {r: 2, c: 1300},
        {r: 3, c: 2100},
        {r: 4, c: 3400},
        {r: 5, c: 5500}
    ],
    /**
     * Fertigkeitstraining und -kosten
     * r raise, t training in weeks, w waiting in weeks, novice,geselle,hüter
     */
    skill_raise_cost: [
        {r: 1, t: 1, w: 2, n: 200, g: 300, h: 500},
        {r: 2, t: 2, w: 3, n: 300, g: 500, h: 800},
        {r: 3, t: 3, w: 5, n: 500, g: 800, h: 1300},
        {r: 4, t: 4, w: 8, n: 800, g: 1300, h: 2100},
        {r: 5, t: 5, w: 13, n: 1300, g: 2100, h: 3400},
        {r: 6, t: 6, w: 21, n: 2100, g: 3400, h: 5500},
        {r: 7, t: 7, w: 34, n: 3400, g: 5500, h: 8900},
        {r: 8, t: 8, w: 55, n: 5500, g: 8900, h: 14400},
        {r: 9, t: 9, w: 89, n: 8900, g: 14400, h: 23300},
        {r: 10, t: 10, w: 9999, n: 14400, g: 23300, h: 37700}
    ],
    /**
     * kosten  steigern
     * lpstart - entry
     * neue zauber lernen wie ein novizen talent, range = kreis des zaubers
     */
    raise_cost: {
        "100": [100, 200, 300, 500, 800, 1300, 2100, 3400, 5500, 8900, 14400, 23300, 37700, 61000, 98700],
        "200": [200, 300, 500, 800, 1300, 2100, 3400, 5500, 8900, 14400, 23300, 37700, 61000, 98700, 159700],
        "300": [300, 500, 800, 1300, 2100, 3400, 5500, 8900, 14400, 23300, 37700, 61000, 98700, 159700, 258400],
        "500": [500, 800, 1300, 2100, 3400, 5500, 8900, 14400, 23300, 37700, 61000, 98700, 159700, 258400, 418100],
        "800": [800, 1300, 2100, 3400, 5500, 8900, 14400, 23300, 37700, 61000, 98700, 159700, 258400, 418100, 676.500]
    },

    raiseCost(lpstart: number, nextStep: number) {
        let cost = -1;
        if (CharCreate.raise_cost.hasOwnProperty(lpstart.toString())) {
            if (typeof CharCreate.raise_cost[lpstart][nextStep] === 'undefined') {
            } else cost = parseInt(CharCreate.raise_cost[lpstart][nextStep]);
        }
        return cost;
    },

    /** —Legendenpunktekosten für Talente auf Rang 1—
     * key- niedrigester erreichter kreis
     * 2: zeite
     * 3: dritte
     * 4: virte
     * 5: fünfte und weitere
     */
    additional_disciplines_start: {
        1: {2: 1300, 3: 2100, 4: 3400},
        2: {2: 800, 3: 1300, 4: 3400},
        3: {2: 500, 3: 800, 4: 1300},
        4: {2: 300, 3: 500, 4: 800},
        5: {2: 200, 3: 300, 4: 500},
    },
    // lps_talent
    // Äquivalenter Kreisbereiche
    // Erste Disziplin d:1 c:Kosten [ f: from circle, t: to cirsle, lps LP cost start]
    // Zweite Disziplin   s.o
    // Dritte Disziplin   s.o.
    // Vierte+ Disziplin  s.o.
    // standard: novize 1-4 100, geselle 5-8 200, hüter 9-12 300, meister 13-15 500
    disciplines_equivalent: [
        {d: 1, c: [{f: 1, t: 4, lps: 100}, {f: 5, t: 8, lps: 200}, {f: 9, t: 13, lps: 300}, {f: 13, t: 15, lps: 500}]},
        {d: 2, c: [{f: 1, t: 4, lps: 200}, {f: 5, t: 8, lps: 300}, {f: 9, t: 15, lps: 500}]},
        {d: 3, c: [{f: 1, t: 4, lps: 300}, {f: 5, t: 15, lps: 500}]},
        {d: 4, c: [{f: 1, t: 15, lps: 500}]}
    ],
    disciplineRaise: [
        {new: 1, amount: 0, minStep: 0, exists: 0},
        {new: 2, amount: 5, minStep: 2, exists: 1},
        {new: 3, amount: 6, minStep: 3, exists: 2},
        {new: 4, amount: 7, minStep: 4, exists: 3},
        {new: 5, amount: 8, minStep: 5, exists: 4},
        {new: 6, amount: 9, minStep: 6, exists: 5},
        {new: 7, amount: 10, minStep: 7, exists: 6},
        {new: 8, amount: 11, minStep: 8, exists: 7},
        {new: 9, amount: 12, minStep: 9, exists: 8},
        {new: 10, amount: 13, minStep: 10, exists: 9},
        {new: 11, amount: 14, minStep: 11, exists: 10},
        {new: 12, amount: 15, minStep: 11, exists: 11},
        {new: 13, amount: 16, minStep: 12, exists: 12},
        {new: 14, amount: 17, minStep: 12, exists: 13},
        {new: 15, amount: 18, minStep: 13, exists: 14},
    ]
}
export default CharCreate;